import httpService from '@/services/httpService'
import { convertAdvancedOptionsToURLParams, findUrlBiId } from '@/store/modules/rank-zone/Helper'
// eslint-disable-next-line no-unused-vars
import Sections from '../../../features/reports/rank-zone/sections/Sections'

export const types = {
  ADD_SHARE_OF_VOICE_DATA: 'rank-zone/ADD_SHARE_OF_VOICE_DATA',
  ADD_MSV_DATA: 'rank-zone/ADD_MSV_DATA',
  ADD_SECTIONS_DATA: 'rank-zone/ADD_SECTIONS_DATA',
  ADD_SECTIONS_KEYWORDS_DATA: 'rank-zone/ADD_SECTIONS_KEYWORDS_DATA',
  ADD_SECTIONS_TOTALS_DATA: 'rank-zone/ADD_SECTIONS_TOTALS_DATA',
  RESET_SECTIONS_DATA: 'rank-zone/RESET_SECTIONS_DATA'
}

const state = {
  share_of_voice: [],
  monthly_search_volume: [],
  unfiltered_totals: {},
  sections: []
}

const mutations = {
  [ types.ADD_SHARE_OF_VOICE_DATA ]: function (state, payload) {
    state.share_of_voice = payload
  },
  [ types.ADD_MSV_DATA ]: function (state, payload) {
    state.monthly_search_volume = payload
  },
  [ types.ADD_SECTIONS_DATA ]: function (state, payload) {
    state.sections = payload
  },
  [ types.ADD_SECTIONS_TOTALS_DATA ]: function (state, payload) {
    state.unfiltered_totals = payload
  },
  [ types.RESET_SECTIONS_DATA ]: function (state) {
    state.share_of_voice = []
    state.monthly_search_volume = []
    state.sections = []
    state.unfiltered_totals = {}
  },
  [ types.ADD_SECTIONS_KEYWORDS_DATA ]: function (state, { keywords, urlId }) {
    const url = findUrlBiId(state.sections, urlId)
    if (url) {
      url.children = keywords
    }
  }
}

const loadSectionData = async function (clientId, filters) {
  const msv = JSON.parse(localStorage.getItem('msv')) || {}
  filters.msv = msv[clientId] || 1
  if (filters && filters.advancedFilters) {
    const params = convertAdvancedOptionsToURLParams(filters)
    return httpService.get(`/reports/rankzone-report/section/${clientId}`, { params: params }, { encode: false })
  }
  return httpService.get(`/reports/rankzone-report/section/${clientId}`, { params: filters })
}

const actions = {
  getSectionsData: async function ({ commit, dispatch }, { clientId, filters }) {
    const sections = await loadSectionData(clientId, filters)
    if (!sections || !sections.data) {
      return
    }
    commit(types.ADD_MSV_DATA, sections.data[ 'monthly_search_volume' ])
    commit(types.ADD_SHARE_OF_VOICE_DATA, sections.data[ 'share_of_voice' ])
    commit(types.ADD_SECTIONS_DATA, sections.data[ 'sections' ])
    commit(types.ADD_SECTIONS_TOTALS_DATA, sections.data[ 'unfiltered_totals' ])
    return sections
  },
  resetData ({ commit }) {
    commit(types.RESET_SECTIONS_DATA)
  },

  /**
   * set keywords for expanded row in table
   * @param payload received from {@link getKeywordsByUrlIdData()}
   */
  setKeywords ({ commit }, payload) {
    commit(types.ADD_SECTIONS_KEYWORDS_DATA, payload)
  }
}

/**
 * Store keep data for {@link Sections} component
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
